import { lazy, Suspense, useContext } from "react";
import { Outlet } from "react-router-dom";
import { AppContext } from "@/common/hooks/useAppContext";
import { useNavigationState } from "@/router/hooks/useNavigationState";
import { LoaderPage } from "@/shared/ui/LoaderPage";
import { Footer } from "@/widgets/Footer";
import { Header } from "@/widgets/Header";
import { useScrollToTop } from "@/widgets/Layout/useScrollToTop";

const ModalError = lazy(
  () => import(/* webpackChunkName: "modal-error" */ "@/shared/ui/ModalError"),
);

export const Layout = () => {
  useScrollToTop();
  const { pageLoading } = useNavigationState();
  const { errorMessage, setErrorMessage } = useContext(AppContext);
  return (
    <>
      <LoaderPage isLoading={pageLoading} />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      {!!errorMessage && (
        <Suspense fallback={<LoaderPage isLoading />}>
          <ModalError
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </Suspense>
      )}
    </>
  );
};
